import { SearchArcgisFeatureClassesApiRequest } from '../../../types/requests/arcgis-feature-classes/search-arcgis-feature-classes.request';
import { ArcgisFeatureClassApiModel } from '../../../types/models/arcgis-feature-class.model';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';
import { GetArcgisFeatureClassApiRequest } from '../../../types/requests/arcgis-feature-classes/get-arcgis-feature-class.request';
import { AttributeApiModel } from '../../../types/models/attribute.model';

export const getArcgisFeatureClass = <T extends ArcgisFeatureClassApiModel>({
  featureClassId,
  ...params
}: GetArcgisFeatureClassApiRequest) => client.get<T>(`/arcgis-feature-classes/${featureClassId}`, { params });

export const getAttributesForArcgisFeatureClass = ({ featureClassId, ...params }: GetArcgisFeatureClassApiRequest) =>
  client.get<Pick<AttributeApiModel, 'id' | 'name' | 'type' | 'values'>[]>(
    `/arcgis-feature-classes/${featureClassId}/attributes`,
    { params },
  );

export const searchFeatureClasses = <T extends ArcgisFeatureClassApiModel>(
  params: SearchArcgisFeatureClassesApiRequest,
) => client.get<CursorPaginatedApiResponse<T>>(`/arcgis-feature-classes`, { params });
